import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const arStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'دعوة عبر واتساب',
  NLSWhatsappInviteDialogTitle: 'دعوة عبر واتساب',
  NLSWhatsappInviteDialogCopy: 'نسخ الرابط',
  NLSWhatsappInviteDialogShare: 'مشاركة',
  NLSWhatsappSendFromMineAction: 'إرسال من واتساب الخاص بي',
  NLSWhatsappSendFromMineText: 'مرحبًا {name}، معك {sender} من {workspace}.',
  NLSWhatsappSlipQrCaption: 'تواصل معنا عبر واتساب',
  NLSWhatsappChipLinked: 'واتساب متصل',
  NLSWhatsappChipNotYet: 'واتساب: ليس بعد',
  NLSWhatsappChipStopped: 'واتساب: متوقف',
  NLSEduAnnouncementSendWhatsappAction: 'إرسال عبر واتساب',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'إرسال عبر واتساب',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'إرسال',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: 'إرسال إلى {n} من أولياء الأمور',
  NLSEduAnnouncementSendWhatsappSummaryCredits: 'إرسال إلى {n} من أولياء الأمور · حوالي {credits} رصيد',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'مجاني ضمن الحد الأقصى لخطتك',
  NLSEduAnnouncementSendWhatsappReasonOff: 'واتساب معطل لمساحة العمل هذه.',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'تم إيقاف إرسال إعلانات المشرف في الإعدادات.',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'لم يتم العثور على أولياء أمور بموافقة هاتفية مؤكدة.',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'إرسال واتساب متوقف مؤقتًا لعدم كفاية الرصيد.',
  NLSEduAnnouncementSentWhatsappCount: 'تم الإرسال عبر واتساب إلى {count}',
  NLSCommonRailPageShellSidecarSheet: "لوحة التفاصيل",
  NLSCommonActionBackToWorkspace: 'العودة للمساحة',
  NLSCommonActionDownload: 'تنزيل',
  NLSCommonActionOpen: 'فتح',
  NLSCommonActionReloadThisTab: 'إعادة تحميل التبويب',
  NLSCommonActionBack: 'رجوع',
  NLSCommonActionCancel: 'إلغاء',
  NLSCommonActionContinue: 'متابعة',
  NLSCommonActionSignOut: 'تسجيل الخروج',
  NLSCommonActionRetryLoadingWorkspaces: 'إعادة تحميل المساحات',
  NLSCommonActionRetrying: 'جار إعادة المحاولة...',
  NLSCommonActionMarkUpInDesign: 'تعليق في Design',
  NLSCommonAriaAccessDenied: 'تم رفض الوصول',
  NLSCommonAriaClosePreview: 'إغلاق المعاينة',
  NLSCommonAriaConnectionStatus: 'حالة الاتصال',
  NLSCommonAriaPreviewAttachment: 'معاينة {label}',
  NLSCommonEmptyNoActions: 'لا إجراءات',
  NLSCommonEmptyNoOptions: 'لا خيارات',
  NLSCommonErrorGeneric: 'حدث خطأ ما.',
  NLSCommonInputSearchPlaceholder: 'بحث',
  NLSCommonInputSearchEllipsisPlaceholder: 'بحث…',
  NLSCommonInputSearchOptionsPlaceholder: 'بحث في الخيارات',
  NLSCommonInputSelectPlaceholder: 'اختيار',
  NLSCommonInputSelectEllipsisPlaceholder: 'اختيار…',
  NLSCommonStatusLoading: 'جار التحميل',
  NLSCommonLanguageAriaLabel: 'لغة التطبيق',
  NLSCommonLanguageLabel: 'اللغة',
  NLSCommonAccessDeniedDefaultMessage: 'دور حسابك لا يمكنه الوصول إلى هذه المنطقة.',
  NLSCommonAccessDeniedTitle: 'تم رفض الوصول',
  NLSCommonConnectivityDescription: 'فشل آخر طلب لأن هذا الجهاز يبدو غير متصل. أعد الاتصال ثم حاول الإجراء مرة أخرى. ستبقى مساحة العمل الحالية مفتوحة في الخلف.',
  NLSCommonConnectivityEyebrow: 'انقطع الاتصال',
  NLSCommonConnectivityRequestPaused: 'تم إيقاف الطلب',
  NLSCommonConnectivityTitle: 'تعذر على Timelining الوصول إلى الشبكة.',
  NLSCommonPreviewAttachmentUnavailable: 'المرفق غير متاح.',
  NLSCommonPreviewFormatUnavailable: 'المعاينة غير متاحة لهذا التنسيق هنا. ما زال بإمكانك فتح الملف الأصلي أو تنزيله.',
  NLSCommonPreviewKindAsset: 'أصل',
  NLSCommonPreviewKindAudio: 'صوت',
  NLSCommonPreviewKindDocument: 'مستند',
  NLSCommonPreviewKindFile: 'ملف',
  NLSCommonPreviewKindImage: 'صورة',
  NLSCommonPreviewKindLink: 'رابط',
  NLSCommonPreviewKindSpreadsheet: 'جدول',
  NLSCommonPreviewKindTimelineItem: 'عنصر زمني',
  NLSCommonPreviewKindVideo: 'فيديو',
  NLSCommonPreviewPreparingText: 'يتم تجهيز معاينة النص...',
  NLSCommonPreviewTextBlocked: 'معاينة النص محظورة لهذا الملف. افتح الأصل أو نزله.',
  NLSCommonPreviewTextTruncated: 'تم اختصار المعاينة',
  NLSCommonTabErrorBody: 'باقي التطبيق يعمل. استخدم التبويبات السفلية للتنقل، أو أعد تحميل هذا التبويب.',
  NLSCommonTabErrorTitle: 'تعطل هذا التبويب',
  NLSSettingsTitleSettings: 'الإعدادات',
  NLSSettingsGroupSystem: 'إعدادات النظام',
  NLSSettingsSectionBilling: 'الفوترة',
  NLSSettingsSectionBillingSubtitle: 'سجل الأرصدة ورصيد الملف الشخصي والمستوى النشط.',
  NLSSettingsCreditPersonalWallet: 'المحفظة الشخصية',
  NLSSettingsCreditFilterPurchases: 'المشتريات',
  NLSSettingsStatusTransactionsPermission: 'لا تملك إذن عرض هذا السجل.',
  NLSProfileStatusNotSet: 'غير محدد',
  NLSProfileLabelDisplayPreference: 'تفضيل العرض',
  NLSInvitesHubTitle: 'الدعوات',
  NLSInvitesHubEyebrow: 'مركز الدعوات',
  NLSInvitesActionNewMemberInvite: 'دعوة عضو جديدة',
  NLSInvitesCategoryMembers: 'الأعضاء النشطون',
  NLSWorkbenchAutomateTitle: 'الأتمتة',
  NLSWorkbenchAutomateNavWorkflows: 'سير العمل',
  NLSWorkbenchAutomateChipNeedsAttention: 'يحتاج انتباها',
  NLSWorkbenchDesignNavBound: 'استوديو Bound',
  NLSWorkbenchExploreSearchPublic: 'بحث في المساحات العامة',
  NLSWorkbenchOverviewModeTeam: 'الفريق',
  NLSWorkbenchOverviewSectionHero: 'البطل',
  NLSWorkbenchFocusTitle: 'التركيز',
  NLSWorkbenchFocusFreeformTitle: 'تركيز حر',
  NLSWorkbenchFocusSoundSilence: 'صمت عميق',
  NLSExperienceYourPageEyebrow: 'صفحتك',
  NLSExperienceYourTabAchievements: 'الإنجازات',
  NLSExperienceRarityLegendary: 'أسطوري',
  NLSExperienceSpinTierLucky: 'محظوظ',
  NLSExperienceFilterClaimable: 'قابل للمطالبة',
  NLSExperienceSpinVaultTitle: 'خزنة اللفات',
  NLSExperienceMasteryTracksTitle: 'مسارات الإتقان',
  NLSExperienceGuardianSanctum: 'محراب الحارس',
  NLSExperienceNotificationSignalStream: 'تدفق الإشارات',
  NLSExperienceNotificationsTitle: 'الإشعارات',
  NLSExperienceNotificationGroupToday: 'اليوم',
  NLSExperienceNotificationRelativeYesterday: 'أمس',
  NLSExperienceRaidArenaWarRoom: 'غرفة الحرب',
  NLSExperienceRaidTitle: 'الغارة',
  NLSExperienceRaidForgeBoss: 'اصنع الزعيم',
  NLSExperienceDebugCapture: 'التقاط التشخيص',
  NLSExperienceDebugEndTitle: 'إنهاء وضع التشخيص',
  NLSAuthEyebrowCloudWorkspace: 'مساحة سحابية',
  NLSAuthEyebrowHelperAccess: 'وصول المساعد',
  NLSAuthTitleCloudWorkspace: 'ارسم أهدافك. أو أهداف فريقك.',
  NLSAuthTitleHelperPhone: 'سجّل الدخول بهاتفك.',
  NLSAuthActionCheckSession: 'فحص الجلسة',
  NLSAuthActionContinueGoogle: 'المتابعة عبر Google',
  NLSAuthActionOpeningGoogle: 'جار فتح Google...',
  NLSAuthActionSendOtp: 'إرسال الرمز',
  NLSAuthActionSendingOtp: 'جار إرسال الرمز...',
  NLSAuthActionVerifySignIn: 'تحقق وادخل',
  NLSAuthActionVerifying: 'جار التحقق...',
  NLSAuthActionUseDifferentNumber: 'استخدم رقمًا آخر',
  NLSAuthFieldPhoneNumber: 'رقم الهاتف',
  NLSAuthFieldVerificationCode: 'رمز التحقق',
  NLSOnboardingEyebrowNewSpace: 'مساحة جديدة بانتظارك',
  NLSOnboardingTitleBegin: 'من أين تريد أن تبدأ؟',
  NLSOnboardingPersonalTitle: 'مساحة شخصية',
  NLSOnboardingActionLaunchPersonal: 'فتح المساحة الشخصية',
  NLSOnboardingTeamTitleCreate: 'مساحة فريق',
  NLSOnboardingActionExploreTeam: 'استكشاف خيارات الفريق',
  NLSOnboardingTabInvites: 'الدعوات',
  NLSOnboardingTabDiscover: 'استكشاف',
  NLSOnboardingTabCreateNew: 'إنشاء',
  NLSShellRailSectionBoard: 'اللوحة',
  NLSShellRailSectionControls: 'التحكم',
  NLSShellRailDays: 'أيام',
  NLSShellRailPersonalWallet: 'المحفظة الشخصية',
  NLSShellRailTileDashboard: 'لوحة التحكم',
  NLSShellRailTileCalendar: 'التقويم',
  NLSShellRailTileMembers: 'الأعضاء',
  NLSShellRailTileSettings: 'الإعدادات',
  NLSShellRailTileNotifications: 'الإشعارات',
  NLSShellRailTileLogOut: 'خروج',
  NLSDashboardViewTimeline: 'الخط الزمني',
  NLSDashboardViewConstellation: 'الكوكبة',
  NLSDashboardViewRadar: 'الرادار',
  NLSDashboardViewJourney: 'المسار',
  NLSDashboardViewGrid: 'الشبكة',
  NLSDashboardViewHeatmap: 'خريطة الحرارة',
  NLSDashboardViewStripboard: 'الشريط',
  NLSDashboardViewWarRoom: 'غرفة العمليات',
  NLSDashboardViewReliability: 'الموثوقية',
  NLSDashboardViewPerimeter: 'المحيط',
  NLSDashboardViewLootDrop: 'المكافآت',
  NLSDashboardActionWatch: 'مراقبة',
  NLSDashboardActionWatching: 'تتم المراقبة',
  NLSDashboardActionStopWatching: 'إيقاف المراقبة',
  NLSDashboardActionScrollLeftLarge: 'تمرير كبير لليسار',
  NLSDashboardActionScrollLeft: 'تمرير لليسار',
  NLSDashboardActionScrollRight: 'تمرير لليمين',
  NLSDashboardActionScrollRightLarge: 'تمرير كبير لليمين',
  NLSDashboardActionZoomOut: 'تصغير',
  NLSDashboardActionZoomIn: 'تكبير',
  NLSDashboardActionFitFullTimeline: 'ملاءمة الخط',
  NLSDashboardActionFocusSelectedItem: 'تركيز المحدد',
  NLSDashboardActionViewLegend: 'مفتاح العرض',
  NLSDashboardActionShowViewLegend: 'إظهار المفتاح',
  NLSDashboardActionHideViewLegend: 'إخفاء المفتاح',
  NLSDashboardActionExpandDashboardView: 'توسيع العرض',
  NLSDashboardActionExitExpandedView: 'الخروج من العرض الموسع',
  NLSDashboardAriaViewSelect: 'عرض اللوحة',
  NLSDashboardAriaDashboardZoom: 'تكبير اللوحة',
  NLSDashboardAriaDashboardViewControls: 'عناصر تحكم عرض اللوحة',
  NLSDashboardStatusLoadingCanvas: 'جار تحميل اللوحة...',
  NLSDashboardEmptyAiMagicReady: 'AI Magic جاهز',
  NLSDashboardEmptyWelcomePhraseStart: 'ابدأ مع Timelining',
  NLSDashboardEmptyWelcomePhraseCreate: 'أنشئ خطوطًا زمنية بسهولة',
  NLSDashboardEmptyWelcomePhraseManage: 'أدر التقويمات بطريقة مختلفة',
  NLSDashboardEmptyWelcomePhraseMotion: 'حوّل الخطط إلى حركة',
  NLSDashboardEmptyAiMagicCopy: 'افتح AI Magic من التنقل الجانبي لوصف خطة وإنشاء أهداف ومهام ومهام فرعية وتواريخ.',
  NLSManageActionApplyAndClose: 'تطبيق وإغلاق',
  NLSManageActionApplyStayOpen: 'تطبيق والبقاء',
  NLSManageActionClose: 'إغلاق',
  NLSManageActionCopy: 'نسخ',
  NLSManageActionCut: 'قص',
  NLSManageActionDelete: 'حذف',
  NLSManageActionDeleteForever: 'حذف نهائي',
  NLSManageActionDiscard: 'تجاهل',
  NLSManageActionDiscardAll: 'تجاهل الكل',
  NLSManageActionDiscardAllUnsaved: 'تجاهل المعلّق',
  NLSManageActionDiscardAndClose: 'تجاهل وإغلاق',
  NLSManageActionDrop: 'إسقاط',
  NLSManageActionKeepEditing: 'متابعة التحرير',
  NLSManageActionMove: 'نقل',
  NLSManageActionMoving: 'جار النقل',
  NLSManageActionMoveToBin: 'نقل إلى Bin',
  NLSManageActionPaste: 'لصق',
  NLSManageActionPermanentlyDelete: 'حذف نهائي',
  NLSManageActionSave: 'حفظ',
  NLSManageActionSaveAll: 'حفظ الكل',
  NLSManageActionSaveAllChildItems: 'حفظ الأبناء',
  NLSManageActionSaveToBin: 'حفظ في Bin',
  NLSManageActionYesSure: 'نعم، متأكد',
  NLSManageAriaBoard: 'لوحة Manage',
  NLSManageAriaPageControls: 'تحكم Manage',
  NLSManageAriaWorkspace: 'مساحة Manage',
  NLSManageBoardArchive: 'الأرشيف',
  NLSManageBoardDashboard: 'اللوحة',
  NLSManageDialogPerItemTitle: 'ماذا نفعل بهذه العناصر؟',
  NLSManageFieldBoard: 'اللوحة',
  NLSManageKindGoal: 'هدف',
  NLSManageKindGoalPlural: 'أهداف',
  NLSManageKindItem: 'عنصر',
  NLSManageKindItems: 'عناصر',
  NLSManageKindSubtask: 'مهمة فرعية',
  NLSManageKindTask: 'مهمة',
  NLSManageKindTaskPlural: 'مهام',
  NLSManageTitleClipboardEmpty: 'الحافظة فارغة',
  NLSManageTitleReview: 'مراجعة',
  NLSChecklistActionClose: 'إغلاق',
  NLSChecklistActionCreateItem: 'إنشاء عنصر',
  NLSChecklistActionDelete: 'حذف',
  NLSChecklistActionDeleteNode: 'حذف العقدة',
  NLSChecklistActionDiscard: 'تجاهل',
  NLSChecklistActionEdit: 'تحرير',
  NLSChecklistActionOpenInCanvas: 'فتح في اللوحة',
  NLSChecklistActionReply: 'رد',
  NLSChecklistActionSave: 'حفظ',
  NLSChecklistActionSaveLock: 'حفظ وقفل',
  NLSChecklistActionSaveChanges: 'حفظ التغييرات',
  NLSChecklistActionSaving: 'جار الحفظ...',
  NLSChecklistCardDraftUnsaved: 'مسودة غير محفوظة',
  NLSChecklistCardStatusDone: 'تم',
  NLSChecklistCardStatusOpen: 'مفتوح',
  NLSChecklistCardUntitled: 'قائمة بلا عنوان',
  NLSChecklistCardUpdated: 'تم التحديث {time}',
  NLSChecklistCardWeight: 'الوزن {weight}',
  NLSChecklistCommentActionDelete: 'حذف',
  NLSChecklistCommentActionEdit: 'تحرير',
  NLSChecklistCommentActionReply: 'رد',
  NLSChecklistCommentDeleted: 'تم حذف التعليق',
  NLSChecklistCommentMetaEdited: 'معدل',
  NLSChecklistCommentMetaReply: 'رد',
  NLSChecklistDetailActivityHistory: 'سجل النشاط',
  NLSChecklistDetailAssignee: 'المسند إليه',
  NLSChecklistDetailCreatedBy: 'أنشأه',
  NLSChecklistDetailDependencies: 'التبعيات',
  NLSChecklistDetailDetails: 'التفاصيل',
  NLSChecklistDetailEmpty: 'فارغ',
  NLSChecklistDetailNoDiscussion: 'لا نقاش بعد.',
  NLSChecklistDetailProofGated: 'يتطلب إثباتًا',
  NLSChecklistDetailSet: 'محدد',
  NLSChecklistDetailUnassigned: 'غير مسند',
  NLSChecklistDependencyBlockedByEmpty: 'لا شيء يحجب هذه العقدة.',
  NLSChecklistDependencyBlockedByTitle: 'محجوبة بواسطة',
  NLSChecklistDependencyBlockerForEmpty: 'هذه العقدة لا تحجب شيئًا.',
  NLSChecklistDependencyBlockerForTitle: 'تحجب',
  NLSChecklistFieldBy: 'حتى',
  NLSChecklistFieldDated: 'بتاريخ',
  NLSChecklistFieldDuration: 'مدة',
  NLSChecklistFieldExpenseOutlay: 'النفقة',
  NLSChecklistFieldEstimatedHours: 'الوقت (س)',
  NLSChecklistFieldFrom: 'من',
  NLSChecklistFieldOn: 'في',
  NLSChecklistFieldTimeFrom: 'من',
  NLSChecklistFieldTimeTo: 'إلى',
  NLSChecklistFieldTimeWindow: 'نافذة وقت',
  NLSChecklistFieldWeight: 'الوزن',
  NLSChecklistKindDaily: 'يومي',
  NLSChecklistKindIndividual: 'فردي',
  NLSChecklistKindWeekly: 'أسبوعي',
  NLSChecklistOccurrenceArchived: 'مؤرشف',
  NLSChecklistOccurrenceDailyHistory: 'سجل يومي',
  NLSChecklistOccurrenceNotCompleted: 'غير مكتمل',
  NLSChecklistOccurrenceThisWeek: 'هذا الأسبوع',
  NLSChecklistOccurrenceToday: 'اليوم',
  NLSChecklistOccurrenceUpcoming: 'قادم',
  NLSChecklistOccurrenceWeeklyHistory: 'سجل أسبوعي',
  NLSChecklistProofAutoComplete: 'إكمال تلقائي عند الرفع',
  NLSChecklistProofDropFile: 'أفلت الإثبات أو انقر',
  NLSChecklistProofFile: 'ملف إثبات',
  NLSChecklistProofFileRequired: 'الإثبات مطلوب',
  NLSChecklistProofLocationGate: 'بوابة الموقع',
  NLSChecklistProofPeerVerification: 'تحقق الزميل',
  NLSChecklistProofVideoMemo: 'مذكرة فيديو',
  NLSChecklistProofVoiceNoMemo: 'لا مذكرة',
  NLSChecklistProofVoiceRecording: 'تسجيل',
  NLSChecklistShellJumpThisWeek: 'هذا الأسبوع',
  NLSChecklistShellAlreadyThisWeek: 'أنت على هذا الأسبوع',
  NLSChecklistShellAlreadyToday: 'أنت على اليوم',
  NLSChecklistShellJumpThisWeekAria: 'اذهب لهذا الأسبوع',
  NLSChecklistShellJumpToday: 'اليوم',
  NLSChecklistShellJumpTodayAria: 'اذهب لليوم',
  NLSChecklistShellNextDay: 'اليوم التالي',
  NLSChecklistShellNextWeek: 'الأسبوع التالي',
  NLSChecklistShellPreviousDay: 'اليوم السابق',
  NLSChecklistShellPreviousWeek: 'الأسبوع السابق',
  NLSChecklistStatusClear: 'واضح',
  NLSChecklistStatusOpen: 'مفتوح',
  NLSChecklistStatusBlocked: 'محجوب',
  NLSChatActionAttachFiles: 'إرفاق ملفات',
  NLSChatActionDelete: 'حذف',
  NLSChatActionEdit: 'تحرير',
  NLSChatActionSendMessage: 'إرسال رسالة',
  NLSChatActionTranslate: 'ترجمة',
  NLSChatActionUndoDelete: 'تراجع عن الحذف',
  NLSChatComposerArchivedPlaceholder: 'قناة مؤرشفة',
  NLSChatComposerLockedPlaceholder: 'بانتظار شخص آخر',
  NLSChatComposerMessageAllPlaceholder: 'اكتب لكل الدردشات',
  NLSChatEmptyNoMessages: 'لا توجد رسائل في هذه القناة بعد.',
  NLSChatLabelActive: 'نشط',
  NLSChatLabelArchive: 'الأرشيف',
  NLSChatLabelChannels: 'القنوات',
  NLSChatLabelChatsDiscussions: 'الدردشات والنقاشات',
  NLSChatLabelMembers: 'الأعضاء',
  NLSChatLabelTags: 'الوسوم',
  NLSChatLabelYou: 'أنت',
  NLSChatMessageDeleted: 'تم حذف هذه الرسالة.',
  NLSUploadViewAllUploadsLabel: 'كل الرفعات',
  NLSUploadViewAllUploadsDescription: 'سجل ملفات المساحة',
  NLSUploadViewAiMagicUploadsLabel: 'رفعات AI Magic',
  NLSUploadViewAiMagicUploadsDescription: 'ملفات AI Magic الخاصة',
  NLSUploadViewChatUploadsLabel: 'رفعات الدردشة',
  NLSUploadViewChatUploadsDescription: 'ملفات مشتركة في دردشة المجموعة',
  NLSUploadViewChecklistUploadsLabel: 'القوائم',
  NLSUploadViewChecklistUploadsDescription: 'إثباتات ومذكرات صوت',
  NLSUploadViewMeetingUploadsLabel: 'رفعات الاجتماعات',
  NLSUploadViewMeetingUploadsDescription: 'مستندات مرفقة بالاجتماعات',
  NLSUploadViewBatchQueuesLabel: 'قوائم الدفعات',
  NLSUploadViewBatchQueuesDescription: 'دفعات نشطة ومعلقة',
  NLSUploadViewSyncSchedulerLabel: 'جدولة المزامنة',
  NLSUploadViewSyncSchedulerDescription: 'تشغيلات مجدولة',
  NLSUploadViewStorageAnalyticsLabel: 'تحليلات التخزين',
  NLSUploadViewStorageAnalyticsDescription: 'استخدام الخطة والتفصيل',
  NLSUploadNavLockedTitle: 'امسح فلتر الملف لتصفح هذا القسم.',
  NLSUploadLabelUnlimited: 'غير محدود',
  NLSUploadLabelPending: 'معلق',
  NLSUploadLabelPendingDate: 'تاريخ معلق',
  NLSUploadCountFileOne: '{count} ملف',
  NLSUploadCountFileMany: '{count} ملفات',
  NLSUploadCountUploadOne: '{count} رفعة',
  NLSUploadCountUploadMany: '{count} رفعات',
  NLSUploadCountArtifactOne: '{count} ملف',
  NLSUploadCountArtifactMany: '{count} ملفات',
  NLSUploadCountProviderOne: '{count} مزود',
  NLSUploadCountProviderMany: '{count} مزودين',
  NLSUploadCountChecklistOne: '{count} قائمة',
  NLSUploadCountChecklistMany: '{count} قوائم',
  NLSUploadArtifactCategoryChatAttachment: 'مرفق دردشة',
  NLSUploadArtifactCategoryAiMagicUpload: 'رفعة AI Magic',
  NLSUploadArtifactCategoryFormResponse: 'رد نموذج',
  NLSUploadArtifactCategoryChecklistProof: 'إثبات قائمة',
  NLSUploadArtifactCategoryVoiceMemo: 'مذكرة صوتية',
  NLSUploadArtifactCategoryDesignAsset: 'أصل تصميم',
  NLSUploadArtifactCategoryDriveReference: 'مرجع Drive',
  NLSUploadArtifactCategoryMeetingDocument: 'مستند اجتماع',
  NLSUploadChecklistTypeAll: 'الكل',
  NLSUploadChecklistTypeIndividual: 'فردي',
  NLSUploadChecklistTypeDaily: 'يومي',
  NLSUploadChecklistTypeWeekly: 'أسبوعي',
  NLSUploadChecklistRecurringIndividual: 'فردي',
  NLSUploadChecklistRecurringDaily: 'يومي متكرر',
  NLSUploadChecklistRecurringWeekly: 'أسبوعي متكرر',
  NLSUploadChecklistKindProof: 'إثباتات',
  NLSUploadChecklistKindVoiceMemo: 'مذكرات صوت',
  NLSUploadChecklistKindProofShort: 'إثبات',
  NLSUploadChecklistKindMemoShort: 'مذكرة',
  NLSFormsIdentityTitle: 'النماذج',
  NLSFormsIdentitySubtitle: 'محرك الإدخال',
  NLSFormsAriaWorkspace: 'مساحة النماذج',
  NLSFormsSectionHubLabel: 'النماذج',
  NLSFormsSectionHubTone: 'تعريفات',
  NLSFormsSectionTemplatesLabel: 'قوالب',
  NLSFormsSectionTemplatesTone: 'حزم جاهزة',
  NLSFormsSectionDraftsLabel: 'مسودات',
  NLSFormsSectionDraftsTone: 'قيد العمل',
  NLSFormsSectionArchiveLabel: 'الأرشيف',
  NLSFormsSectionArchiveTone: 'تعريفات محفوظة',
  NLSFormsSectionAssignLabel: 'إسناد',
  NLSFormsSectionAssignTone: 'طلبات',
  NLSFormsSectionAssignedLabel: 'لك',
  NLSFormsSectionAssignedTone: 'طابور الرد',
  NLSFormsSectionResponsesLabel: 'الردود',
  NLSFormsSectionResponsesTone: 'السجل',
  NLSFormsSectionSettingsLabel: 'الإعدادات',
  NLSFormsSectionSettingsTone: 'السياسة',
  NLSFormsActionCreateNewForm: 'إنشاء نموذج',
  NLSFormsActionRequestMembers: 'طلب ردود',
  NLSFormsActionOpenLiveForm: 'فتح النموذج',
  NLSFormsActionSubmitResponse: 'إرسال الرد',
  NLSFormsActionSaveForm: 'حفظ النموذج',
  NLSFormsActionAssignForm: 'إسناد النموذج',
  NLSFormsActionTagAndAssign: 'وسم وإسناد',
  NLSFormsDialogDirtyTitle: 'تغييرات غير محفوظة',
  NLSFormsStatusDraft: 'مسودة',
  NLSFormsStatusActive: 'نشط',
  NLSFormsStatusArchived: 'مؤرشف',
  NLSFormsStatusPending: 'معلق',
  NLSFormsStatusCompleted: 'مكتمل',
  NLSFormsStatusCancelled: 'ملغى',
  NLSFormsStatusExpired: 'منتهي',
  NLSFormsStatusReviewed: 'مراجع',
  NLSFormsStatusExported: 'مصدر',
  NLSFormsLabelAllStatuses: 'الكل',
  NLSFormsLabelAllItems: 'الكل',
  NLSFormsLabelResponsesOne: '{count} رد',
  NLSFormsLabelResponsesMany: '{count} ردود',
  NLSFormsLabelRequired: 'مطلوب',
  NLSFormsModePreview: 'معاينة',
  NLSFormsModeFill: 'تعبئة',
  NLSFormsModeResponses: 'ردود',
  NLSFormsFieldTypeText: 'نص',
  NLSFormsFieldTypeParagraph: 'فقرة',
  NLSFormsFieldTypeNumber: 'رقم',
  NLSFormsFieldTypeDate: 'تاريخ',
  NLSFormsFieldTypeDropdown: 'قائمة',
  NLSFormsFieldTypeCheckbox: 'اختيار',
  NLSFormsFieldTypeFileUpload: 'ملف',
  NLSMeetingsIdentityTitle: 'الاجتماعات',
  NLSMeetingsIdentitySubtitle: 'تنسيق مباشر',
  NLSMeetingsAriaWorkspace: 'مساحة الاجتماعات',
  NLSMeetingsSectionScheduleLabel: 'الجدولة',
  NLSMeetingsSectionScheduleTone: 'تقويم',
  NLSMeetingsSectionHuddleTone: 'حضور صوتي',
  NLSMeetingsSectionMeetingLabel: 'اجتماعات',
  NLSMeetingsSectionMeetingRoomLabel: 'الغرفة',
  NLSMeetingsSectionMeetingTone: 'الانضمام',
  NLSMeetingsViewDay: 'يوم',
  NLSMeetingsViewWeek: 'أسبوع',
  NLSMeetingsViewMonth: 'شهر',
  NLSMeetingsActionScheduleMeeting: 'جدولة',
  NLSMeetingsActionStartHuddle: 'بدء Huddle',
  NLSMeetingsActionJoinRoom: 'انضمام',
  NLSMeetingsActionNewMeeting: 'اجتماع جديد',
  NLSMeetingsActionJoin: 'انضمام',
  NLSMeetingsActionJoinMeeting: 'انضمام',
  NLSMeetingsActionJoinHuddle: 'دخول Huddle',
  NLSMeetingsActionChat: 'دردشة',
  NLSMeetingsActionDocs: 'مستندات',
  NLSMeetingsActionTranscribe: 'تفريغ',
  NLSMeetingsActionSaveMeeting: 'حفظ الاجتماع',
  NLSMeetingsActionSaveSendUpdates: 'حفظ وإبلاغ',
  NLSMeetingsActionUpdateNew: 'إبلاغ الجدد',
  NLSMeetingsActionUpdateAll: 'إبلاغ الكل',
  NLSMeetingsLabelMembers: 'الأعضاء',
  NLSMeetingsLabelPeople: 'الأشخاص',
  NLSMeetingsLabelChannels: 'القنوات',
  NLSMeetingsLabelMeetingHub: 'مركز الاجتماعات',
  NLSMeetingsLabelMeetingDetails: 'التفاصيل',
  NLSMeetingsLabelTotal: 'الإجمالي',
  NLSMeetingsLabelUpcoming: 'القادمة',
  NLSMeetingsLabelCalendar: 'التقويم',
  NLSMeetingsLabelMeetingOne: 'اجتماع',
  NLSMeetingsLabelMeetingMany: 'اجتماعات',
  NLSMeetingsLabelFromToday: 'من اليوم',
  NLSMeetingsLabelBusySlots: 'أوقات مشغولة',
  NLSMeetingsLabelListening: 'يستمع',
  NLSMeetingsLabelSpeaking: 'يتحدث',
  NLSMeetingsLabelReady: 'جاهز',
  NLSMeetingsReadinessOptional: 'مزامنة التقويم اختيارية',
  NLSMeetingsReadinessOpenLinkHub: 'فتح Link Hub',
  NLSAiAriaOpenChatHistory: 'فتح السجل',
  NLSAiAriaCloseChatHistory: 'إغلاق السجل',
  NLSAiAriaChatHistory: 'سجل محادثات الذكاء',
  NLSAiAriaActionsFor: 'إجراءات {label}',
  NLSAiActionNewChat: 'محادثة جديدة',
  NLSAiActionRename: 'إعادة تسمية',
  NLSAiActionDelete: 'حذف',
  NLSAiActionAdd: 'إضافة',
  NLSAiActionRetry: 'إعادة المحاولة',
  NLSAiActionReject: 'رفض',
  NLSAiActionStop: 'إيقاف',
  NLSAiActionEdit: 'تحرير',
  NLSAiActionSave: 'حفظ',
  NLSAiActionSaving: 'جار الحفظ...',
  NLSAiActionSaved: 'محفوظ',
  NLSAiActionDiscard: 'تجاهل',
  NLSAiActionYesIAmSure: 'نعم، أنا متأكد',
  NLSAiActionReviewDependencies: 'مراجعة الاعتماديات',
  NLSAiActionReviewPatches: 'مراجعة التغييرات',
  NLSAiActionReviewPatch: 'مراجعة التغيير',
  NLSAiActionMoveToManage: 'نقل إلى Manage',
  NLSAiActionCollapseGoal: 'طي الهدف',
  NLSAiActionExpandGoal: 'توسيع الهدف',
  NLSAiActionCollapseTask: 'طي المهمة',
  NLSAiActionExpandTask: 'توسيع المهمة',
  NLSAiActionCollapseSubtask: 'طي المهمة الفرعية',
  NLSAiActionExpandSubtask: 'توسيع المهمة الفرعية',
  NLSAiActionSnoozeSuggestion: 'تأجيل الاقتراح',
  NLSAiActionAcceptSuggestion: 'قبول الاقتراح',
  NLSAiActionDismissSuggestion: 'رفض الاقتراح',
  NLSAiComposerAddContext: 'إضافة سياق',
  NLSAiComposerOptions: 'خيارات AI Magic',
  NLSAiComposerContextCount: 'السياق {count}/{limit}',
  NLSAiComposerAddToContext: 'إضافة إلى السياق',
  NLSAiComposerBack: 'رجوع',
  NLSAiComposerAddPhotosFiles: 'إضافة صور وملفات',
  NLSAiComposerAddPhotosFilesHint: 'صور و PDF ومستندات وجداول',
  NLSAiComposerAttachPublicLink: 'إرفاق رابط عام',
  NLSAiComposerAttachPublicLinkHint: 'يتحقق Line من صفحات HTTPS',
  NLSAiComposerUseAppAsset: 'استخدام ملف من التطبيق',
  NLSAiComposerUseAppAssetHint: 'الإشارة إلى رفع متاح',
  NLSAiComposerSelectTimelineItems: 'اختيار عناصر الجدول',
  NLSAiComposerSelectedCount: 'أي لوحة - {count} محدد',
  NLSAiComposerOperatingMode: 'وضع التشغيل',
  NLSAiComposerPlanMode: 'وضع الخطة - مهندس الذكاء',
  NLSAiComposerPlanModeHint: 'استراتيجية للقراءة فقط؛ ألغها لإنشاء عمل في التطبيق.',
  NLSAiComposerPastePublicLink: 'الصق رابط HTTPS عام',
  NLSAiComposerChecking: 'جار الفحص...',
  NLSAiComposerLineCanReadLink: 'يمكن لـ Line قراءة الرابط.',
  NLSAiComposerLinkValidationPending: 'تتاح الإضافة بعد التحقق.',
  NLSAiComposerLineCouldNotReachLink: 'تعذر على Line فتح الرابط.',
  NLSAiStatusConfirmed: 'مؤكد',
  NLSAiStatusPendingApproval: 'بحاجة لموافقة',
  NLSAiStatusPendingClarification: 'بحاجة لتفصيل',
  NLSAiStatusRejected: 'مرفوض',
  NLSAiTierDraftedBy: 'مسودة بواسطة {tierLongLabel}',
  NLSAiLabelSystem: 'النظام',
  NLSAiLabelYou: 'أنت',
  NLSAiLabelAttachmentUnavailable: 'المرفق غير متاح.',
  NLSAiAriaAttachedPreviews: 'معاينات المرفقات',
  NLSAiExecutionResultsAria: 'نتائج التنفيذ',
  NLSAiExecutionDetails: 'تفاصيل التنفيذ',
  NLSAiExecutionCompletedFraction: '{completed}/{total} مكتملة',
  NLSAiExecutionDone: 'تم',
  NLSAiExecutionFailed: 'فشل',
  NLSAiQuickActionsAria: 'إجراءات الاقتراح',
  NLSAiClarificationFormAria: 'نموذج توضيح Line',
  NLSAiClarificationEyebrow: 'يحتاج Line إلى تفصيل',
  NLSAiClarificationSelectOption: 'اختر...',
  NLSAiThinkingDefault: 'Line يفكر',
  NLSAiSuggestionGapAnalysis: 'تحليل الفجوات',
  NLSAiSuggestionPastContext: 'سياق سابق',
  NLSAiSuggestionAria: 'اقتراح {kind}',
  NLSAiAmbientSuggestionAria: 'اقتراح Line: {title}',
  NLSAiGoalTreeNoGoals: 'لا توجد أهداف بعد. أنشئ هدفا أولا.',
  NLSAiGoalTreeNoChecklistItems: 'لا عناصر Checklist',
  NLSAiEditExistingAria: 'تحرير هدف أو مهمة أو مهمة فرعية',
  NLSAiEditExistingTitle: 'تحرير العناصر',
  NLSAiEditExistingMenuLabel: 'تحرير العناصر',
  NLSAiEditExistingSummary: 'تحرير العناصر - {count}/3 - هدف واحد',
  NLSAiPendingTreeReviewSaveTitle: 'مراجعة وحفظ - الهدف أولا',
  NLSAiPendingTreeSaveEditsTitle: 'حفظ التغييرات - الهدف أولا',
  NLSAiDiscardSubtaskConfirm: 'حذف هذه المهمة الفرعية؟ لا يمكن التراجع.',
  NLSAiDiscardTaskConfirm: 'حذف هذه المهمة وكل مهامها الفرعية؟ لا يمكن التراجع.',
  NLSAiDiscardGoalConfirm: 'حذف هذا الهدف وكل ما تحته؟ لا يمكن التراجع.',
  NLSAiToastTimelineSaved: 'تم حفظ الجدول.',
  NLSAiToastChangesSaved: 'تم حفظ التغييرات.',
  NLSAiToastCouldNotSaveTimeline: 'تعذر حفظ الجدول.',
  NLSAiToastGenerationCleared: 'تم مسح الإنشاء.',
  NLSAiProposalReadyHeading: 'جاهز للبناء',
  NLSAiProposalTimelineBullet: 'الجدول: {start} -> {end}',
  NLSAiProposalScopeBullet: 'النطاق: {scope}',
  NLSAiProposalTaskCountOne: '{count} مهمة',
  NLSAiProposalTaskCountMany: '{count} مهام',
  NLSAiProposalSubtaskCountOne: '{count} مهمة فرعية',
  NLSAiProposalSubtaskCountMany: '{count} مهام فرعية',
  NLSAiProposalChecklistCountOne: '{count} عنصر قائمة',
  NLSAiProposalChecklistCountMany: '{count} عناصر قائمة',
  NLSAiProposalBuildPrompt: 'قل "build it" أو استخدم زر البناء أدناه لنقل هذا إلى Manage. قل ما تريد تغييره وسأراجع ذلك.',
  NLSAiProposalChangingHint: 'أخبرني بما تريد تغييره وسأراجع هذه المقترح.',
  NLSAiPreviewUnavailable: 'لم تعد هذه المعاينة متاحة. أرسل الطلب مرة أخرى.',
  NLSReportsTitleReports: 'التقارير',
  NLSReportsSubtitleAuditExports: 'تصديرات التدقيق',
  NLSReportsActionEvidenceLibrary: 'مكتبة الأدلة',
  NLSReportsActionNewReport: 'تقرير جديد',
  NLSReportsActionRefresh: 'تحديث',
  NLSReportsActionBack: 'رجوع',
  NLSReportsActionDownload: 'تنزيل',
  NLSReportsActionDownloadLatest: 'تنزيل الأحدث',
  NLSReportsActionGenerateWorkspaceReport: 'إنشاء تقرير المساحة',
  NLSReportsActionGenerateReport: 'إنشاء تقرير',
  NLSReportsActionPreview: 'معاينة',
  NLSReportsActionRegenerate: 'إعادة إنشاء',
  NLSReportsActionRename: 'إعادة تسمية',
  NLSReportsActionRevoke: 'إلغاء',
  NLSReportsActionPrevious: 'السابق',
  NLSReportsActionNext: 'التالي',
  NLSReportsFilterAll: 'الكل',
  NLSReportsLabelComplianceActivity: 'الامتثال والنشاط',
  NLSReportsLabelGovernanceCenter: 'مركز الحوكمة',
  NLSReportsLabelFilters: 'الفلاتر',
  NLSReportsLabelExportedReports: 'التقارير المصدرة',
  NLSReportsLabelWorkspaceActivity: 'نشاط المساحة',
  NLSReportsLabelFullLogs: 'السجلات الكاملة',
  NLSReportsLabelLiveLedger: 'السجل الحي',
  NLSReportsLabelReportProfile: 'ملف التقرير',
  NLSReportsLabelScopeSelection: 'اختيار النطاق',
  NLSReportsLabelReportCategory: 'فئة التقرير',
  NLSReportsLabelTemplateSelection: 'اختيار القالب',
  NLSReportsLabelAdvancedInstructions: 'تعليمات IA متقدمة',
  NLSReportsLabelFiltersGovernance: 'الفلاتر والحوكمة',
  NLSReportsLabelExportFinalization: 'التصدير والإنهاء',
  NLSReportsLabelCreditEstimate: 'تقدير الأرصدة',
  NLSReportsStatusPending: 'معلق',
  NLSReportsStatusLoadingReports: 'جار تحميل التقارير...',
  NLSReportsStatusReportsRestricted: 'إنشاء التقارير محصور بالمديرين',
  NLSReportsStatusNoReportsYet: 'لا توجد تقارير بعد',
  NLSReportsStatusNoReportsBody: 'أنشئ أول تقرير من بيانات الخط الزمني الحية.',
  NLSReportsAuditErrorSignInAgain: 'سجّل الدخول مجددا لعرض Ledger.',
  NLSReportsAuditRetentionMinimalist: 'امتثال مختصر',
  NLSReportsAuditRetentionEnterprise: 'تدقيق كامل للمؤسسة',
  NLSReportsAuditRetentionDays: 'تدقيق كامل {days}ي',
  NLSReportsAuditTabLiveLedger: 'السجل الحي',
  NLSReportsAuditTabLiveLedgerDetail: 'النشاط المحكوم الحالي',
  NLSReportsAuditTabFullLogs: 'السجلات الكاملة',
  NLSReportsAuditTabFullLogsDetail: 'عرض كامل للسجل',
  NLSReportsAuditRequiresFullAudit: 'يتطلب تدقيقا كاملا',
  NLSReportsAuditTabExportedReports: 'التقارير المصدرة',
  NLSReportsAuditTabExportedReportsDetail: 'الخزنة ووظائف التصدير',
  NLSReportsGeneratedPrefix: 'تم الإنشاء:',
  NLSReportsCategoryStatus: 'الحالة',
  NLSReportsCategoryRoadmap: 'خارطة الطريق',
  NLSReportsCategoryDependency: 'التبعيات',
  NLSReportsCategoryBudget: 'الميزانية',
  NLSReportsCategoryResource: 'الموارد',
  NLSReportsCategoryVelocity: 'السرعة',
  NLSReportsCategoryPerformance: 'الأداء',
  NLSReportsCategoryCompliance: 'الامتثال',
  NLSReportsCategoryUserActivity: 'نشاط المستخدم',
  NLSReportsCategoryCustom: 'مخصص',
  NLSReportsDepthEssential: 'أساسي',
  NLSReportsDepthPremium: 'ممتاز',
  NLSReportsDepthBoardroom: 'مجلس الإدارة',
  NLSReportsDestinationLocal: 'تنزيل محلي',
  NLSLinkHubIdentitySubtitle: 'اربط أدوات الفريق وزامن البيانات الحية.',
  NLSLinkHubAriaIntegrationCategories: 'فئات التكامل',
  NLSLinkHubAriaConnectionDetails: 'تفاصيل الاتصال',
  NLSLinkHubAriaCloseConnectionDetails: 'إغلاق تفاصيل الاتصال',
  NLSLinkHubCategoryAll: 'الكل',
  NLSLinkHubCategoryProjects: 'المشاريع',
  NLSLinkHubCategoryDocuments: 'المستندات',
  NLSLinkHubCategoryCalendar: 'التقويم',
  NLSLinkHubCategoryCommunication: 'التواصل',
  NLSLinkHubCategoryTitleAll: 'كل التكاملات',
  NLSLinkHubCategoryTitleProjects: 'تكاملات المشاريع',
  NLSLinkHubCategoryTitleDocuments: 'تكاملات المستندات',
  NLSLinkHubCategoryTitleCalendar: 'تكاملات التقويم',
  NLSLinkHubCategoryTitleCommunication: 'تكاملات التواصل',
  NLSLinkHubLabelRegistryGroup: 'مجموعة السجل',
  NLSLinkHubLabelLiveMetadata: 'بيانات حية',
  NLSLinkHubLabelProvider: 'المزود',
  NLSLinkHubLabelConnectionDetails: 'تفاصيل الاتصال',
  NLSLinkHubLabelStatus: 'الحالة',
  NLSLinkHubLabelLastSync: 'آخر مزامنة',
  NLSLinkHubLabelProviderId: 'معرف المزود',
  NLSLinkHubLabelRegistryPhase: 'مرحلة السجل',
  NLSLinkHubLabelRuntimeLifecycle: 'دورة التشغيل',
  NLSLinkHubLabelAiUsable: 'متاح للذكاء',
  NLSLinkHubLabelNotAiUsable: 'غير متاح للذكاء',
  NLSLinkHubLabelAuthorizedScopes: 'النطاقات المصرح بها',
  NLSLinkHubIntegrationCountOne: '{count} تكامل',
  NLSLinkHubIntegrationCountMany: '{count} تكاملات',
  NLSLinkHubUsageConnectedPending: 'متصلة · {pending} معلقة',
  NLSLinkHubStatusConnected: 'متصل',
  NLSLinkHubStatusAwaitingAuth: 'بانتظار التفويض',
  NLSLinkHubStatusTierLimitReached: 'تم بلوغ حد الخطة',
  NLSLinkHubStatusConfigurationNeeded: 'يلزم إعداد',
  NLSLinkHubStatusRequiresAuth: 'يتطلب تفويضا',
  NLSLinkHubStatusChecking: 'جار الفحص...',
  NLSLinkHubRuntimeActive: 'نشط',
  NLSLinkHubRuntimeConnecting: 'جار الاتصال',
  NLSLinkHubRuntimeReauthRequired: 'يلزم تفويض جديد',
  NLSLinkHubRuntimeDisconnected: 'غير متصل',
  NLSLinkHubRuntimeDisabled: 'معطل',
  NLSLinkHubRuntimeDegraded: 'متدهور',
  NLSLinkHubRuntimeRateLimited: 'مقيد بالمعدل',
  NLSLinkHubRuntimeFailed: 'فشل',
  NLSLinkHubRuntimeUnknown: 'غير معروف',
  NLSLinkHubRuntimeNoDiagnostics: 'لم يبلغ هذا المزود عن تشخيصات التشغيل بعد.',
  NLSLinkHubRuntimeInfrastructureMissing: 'بنية المزود غير مهيأة.',
  NLSLinkHubPhaseOne: 'المرحلة 1',
  NLSLinkHubPhaseTwo: 'المرحلة 2',
  NLSLinkHubPhaseRoadmap: 'خارطة المرحلة 2',
  NLSLinkHubPhaseTestingEnabled: 'تجاوز الاختبار مفعل',
  NLSLinkHubActionManagePlan: 'إدارة الخطة',
  NLSLinkHubActionConnect: 'اتصال',
  NLSLinkHubActionConnectProvider: 'اتصال بالمزود',
  NLSLinkHubActionConnectNamedProvider: 'اتصال بـ {name}',
  NLSLinkHubActionReauthenticate: 'إعادة التفويض',
  NLSLinkHubActionReauthenticateProvider: 'إعادة تفويض المزود',
  NLSLinkHubActionOpeningProvider: 'جار فتح المزود...',
  NLSLinkHubActionOpenDetails: 'فتح التفاصيل',
  NLSLinkHubActionSyncNow: 'زامن الآن',
  NLSLinkHubActionSyncInProgress: 'المزامنة قيد التنفيذ...',
  NLSLinkHubActionRefreshing: 'جار التحديث...',
  NLSLinkHubActionForceRefreshReadiness: 'تحديث الجاهزية',
  NLSLinkHubActionConnectWebhook: 'اتصال webhook',
  NLSLinkHubActionEncrypting: 'جار التشفير...',
  NLSLinkHubActionSaveEncryptedWebhook: 'حفظ webhook مشفر',
  NLSLinkHubActionRevoking: 'جار الإلغاء...',
  NLSLinkHubActionRevokeAccess: 'إلغاء الوصول',
  NLSLinkHubCardOpenDetailsAria: 'فتح تفاصيل اتصال {name}',
  NLSLinkHubCardCompleteProviderAuthorization: 'أكمل تفويض المزود',
  NLSLinkHubCardUpgradePlanToConnect: 'رق الخطة للاتصال',
  NLSLinkHubCardRoadmapIntegration: 'تكامل في الخارطة',
  NLSLinkHubCardSecretsUnavailable: 'الأسرار غير متاحة',
  NLSLinkHubAdminRequiredManage: 'يلزم دور admin لإدارة التكاملات',
  NLSLinkHubAdminRequiredTitle: 'يلزم admin',
  NLSLinkHubAdminRequiredBody: 'اطلب من admin في المساحة ربط التكاملات أو إلغاءها.',
  NLSLinkHubAdminRequiredRevoke: 'يلزم دور admin لإلغاء الوصول',
  NLSLinkHubConfigPhaseTwoBody: 'هذا المزود مدرج لمرحلة Link Hub مستقبلية.',
  NLSLinkHubConfigMissingBody: 'تنقص أسرار المزود أو إعدادات التشغيل.',
  NLSLinkHubInputSigningSecret: 'سر التوقيع',
  NLSLinkHubRevokeWarningBody: 'إلغاء الوصول يوقف المزامنات المستقبلية حتى تعيد ربط المزود.',
  NLSLinkHubDialogRevokeTitle: 'إلغاء {provider}؟',
  NLSLinkHubDialogRevokeMessage: 'هذا يزيل الوصول المحفوظ للتكامل المحدد.',
  NLSLinkHubEmptyNoIntegrationsTitle: 'لا تكاملات هنا',
  NLSLinkHubEmptyNoIntegrationsBody: 'جرب فئة أخرى.',
  NLSLinkHubEmptySelectIntegrationTitle: 'اختر تكاملا',
  NLSLinkHubEmptySelectIntegrationBody: 'اختر مزودا لفحص الجاهزية والنطاقات وحالة المزامنة.',
  NLSLinkHubEmptyNoScopesRecorded: 'لا نطاقات مسجلة.',
  NLSLinkHubNoSuccessfulSyncYet: 'لا مزامنة ناجحة بعد',
  NLSLinkHubSyncJobCompleted: 'Job {id} · {status} · {count} تغييرات',
  NLSLinkHubCallbackSuccess: 'تم اتصال {provider}.',
  NLSLinkHubCallbackError: 'تعذر إكمال OAuth. لم تحفظ تغييرات الاتصال.',
  NLSLinkHubToastDebugOAuthBlocked: 'إعادة توجيه OAuth معطلة أثناء تفعيل debug bypass.',
  NLSLinkHubToastCouldNotInitiateOAuth: 'تعذر بدء OAuth.',
  NLSLinkHubToastAccessRevoked: 'تم إلغاء وصول {provider}.',
  NLSLinkHubToastCouldNotRevokeProvider: 'تعذر إلغاء المزود.',
  NLSLinkHubToastDebugWebhookBlocked: 'حفظ webhook معطل أثناء تفعيل debug bypass.',
  NLSLinkHubToastGenericWebhookConnected: 'تم اتصال webhook عام.',
  NLSLinkHubToastCouldNotSaveWebhook: 'تعذر حفظ webhook.',
  NLSLinkHubToastSyncQueued: 'تم وضع مزامنة {provider} في الطابور.',
  NLSLinkHubToastCouldNotQueueSync: 'تعذر وضع المزامنة في الطابور.',
  NLSLinkHubTeamRequiredEyebrow: 'يلزم مساحة فريق',
  NLSLinkHubUnavailableTitle: 'Link Hub غير متاح',
  NLSLinkHubTeamRequiredBody: 'التكاملات الخارجية محصورة بمساحات الفريق.',
  NLSLinkHubRestrictedEyebrow: 'مقيد',
  NLSLinkHubAccessRequiredTitle: 'يلزم وصول إلى Link Hub',
  NLSLinkHubAccessRequiredBody: 'سياسة أذونات المساحة لا تسمح بهذه الصفحة.',
  NLSResourcesActionManagePlan: 'إدارة الخطة',
  NLSResourcesBudgetSubtitle: 'مخطط مالي',
  NLSResourcesBudgetTabLedger: 'السجل',
  NLSResourcesBudgetTitle: 'الميزانية',
  NLSResourcesQuotaTabManagement: 'الإدارة',
  NLSResourcesQuotaTargetWeightedProgress: 'تقدم موزون',
  NLSResourcesQuotaTitle: 'الحصص',
  NLSResourcesReadinessTitle: 'جاهزية الموارد',
  NLSResourcesSignalBudgetRisk: 'خطر الميزانية',
  NLSResourcesSignalQuotaImpact: 'أثر الحصة',
  NLSResourcesSignalStockShort: 'نقص المخزون',
  NLSResourcesStockStatusAvailable: 'متاح',
  NLSResourcesStockStatusMaintenance: 'صيانة',
  NLSResourcesStockTitle: 'المخزون',
  NLSMemberTabTodos: 'المهام',
  NLSMemberTabBoard: 'اللوحة',
  NLSMemberTabAiMagic: 'الذكاء',
  NLSMemberTabNexus: 'المركز',
  NLSMemberTabControls: 'التحكم',
  NLSMemberSubtabStripboard: 'المسار',
  NLSMemberSubtabReview: 'مراجعة',
  NLSMemberSubtabFolder: 'مجلد',
  NLSMemberSubtabHistory: 'السجل',
  NLSMemberSubtabPulse: 'النبض',
  NLSMemberSubtabForms: 'النماذج',
  NLSMemberSubtabSync: 'المزامنة',
  NLSMemberSubtabAutomations: 'الأتمتة',
  NLSMemberSubtabAudit: 'التدقيق',
  NLSMemberSubtabMembers: 'الأعضاء',
  NLSMemberSubtabChat: 'الدردشة',
  NLSMemberSubtabCalendar: 'التقويم',
  NLSMemberSubtabMeetings: 'الاجتماعات',
  NLSMemberStatusCreated: 'منشأ',
  NLSMemberStatusAssigned: 'مسند',
  NLSMemberStatusAccepted: 'مقبول',
  NLSMemberStatusOngoing: 'جار',
  NLSMemberStatusAssessing: 'تقييم',
  NLSMemberStatusCompleted: 'مكتمل',
  NLSMemberStatusNotRequired: 'غير مطلوب',
  NLSMemberStatusPostponed: 'مؤجل',
  NLSMemberFilterAll: 'الكل',
  NLSMemberBoardProofNeeded: 'تحتاج دليلا',
  NLSMemberBoardLocationNeeded: 'تحتاج موقعا',
  NLSMemberBoardReviewPending: 'قيد المراجعة',
  NLSMemberBoardTitle: 'سير العمل',
  NLSMemberBoardSyncing: 'جار المزامنة',
  NLSMemberBoardSynced: 'متزامن',
  NLSMemberBoardViewOnly: 'عرض فقط',
  NLSHelperTabTodos: 'المهام',
  NLSHelperTabCalendar: 'التقويم',
  NLSHelperTabMeetings: 'الاجتماعات',
  NLSHelperTabChat: 'الدردشة',
  NLSHelperTabControls: 'التحكم',
  NLSHelperSubtabScan: 'مسح',
  NLSHelperSubtabMe: 'أنا',
  NLSHelperSubtabForms: 'نماذج',
  NLSHelperSubtabSync: 'مزامنة',
  NLSHelperTaskEmptyTitle: 'لا مهام',
  NLSHelperTaskProof: 'دليل',
  NLSHelperTaskLocation: 'موقع',
  NLSHelperTaskUploadProof: 'رفع دليل',
  NLSHelperTaskCheckIn: 'تسجيل',
  NLSHelperScanChooseTarget: 'اختر الهدف',
  NLSHelperScanNoMatchingTarget: 'لا هدف.',
  NLSHelperSettingsTitle: 'الإعدادات',
  NLSHelperSettingsLanguage: 'اللغة',
  NLSCapacitorRedirecting: 'جار التحويل...',
  NLSOpsRequestKindReliefNeeded: 'طلب بديل',
  NLSOpsRequestKindIncident: 'حادث',
  NLSOpsRequestKindClientComplaint: 'شكوى العميل',
  NLSOpsRequestKindSupplyRequest: 'طلب إمدادات',
  NLSOpsRequestKindPm: 'صيانة وقائية',
  NLSOpsRequestKindCalibration: 'معايرة',
  NLSOpsReliefNeededTitle: 'مطلوب بديل: {roleLabel} في {placeName} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'مواقع المناوبة حسب الموقع والوردية · يؤدي الغياب إلى طلب بديل',
  NLSOpsSitesSelectSite: 'حدد الموقع',
  NLSOpsSitesDay: 'اليوم',
  NLSOpsSitesSelectShift: 'حدد الوردية',
  NLSOpsSitesPostsBoardTitle: 'المناوبات والبدلاء',
  NLSOpsSitesColPost: 'الموقع',
  NLSOpsSitesColNeeds: 'الاحتياج',
  NLSOpsSitesColOnDuty: 'في الخدمة',
  NLSOpsSitesColState: 'الحالة',
  NLSOpsSitesStateCovered: 'مغطى',
  NLSOpsSitesStateShort: 'نقص',
  NLSOpsSitesStateReliefNeeded: 'مطلوب بديل',
  NLSOpsSitesStateReliefAssigned: 'تم تعيين بديل',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'غائب',
  NLSOpsSitesReliefInbox: 'صندوق البدلاء',
  NLSOpsSitesReliefFootnote: 'تسجيل الغياب يرفع طلب بديل تلقائياً ويحذر من نقص التغطية (A6).',
  NLSOpsSitesFreeCandidates: 'المرشحون المتاحون:',
  NLSOpsSitesOffToday: 'في إجازة اليوم',
  NLSOpsSitesAssignBtn: 'تعيين',
  NLSOpsSitesAssignCandidateBtn: 'تعيين {name}',
  NLSOpsSitesAssignDialogTitle: 'تعيين بديل',
  NLSOpsSitesPrintPostSheet: 'طباعة ورقة المناوبة',
  NLSOpsSitesNoPosts: 'لم يتم تكوين مواقع مناوبة لهذا الموقع.',
  NLSOpsSitesNoReliefNeeded: 'لا يلزم بدلاء.',
  NLSOpsSitesNoSites: 'لم يتم العثور على مواقع عملاء.',
  NLSOpsSitesNoShifts: 'لا توجد ورديات متاحة.',
  NLSOpsSitesPostSheetTitle: 'ورقة المناوبة · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'تعذر تعيين البديل: الطلب لم يعد مفتوحاً.',
  NLSOpsSitesErrorOnLeave: 'تعذر تعيين البديل: الشخص في إجازة معتمدة.',
  NLSOpsSitesErrorDoubleBooked: 'تعذر تعيين البديل: الشخص معين بالفعل في هذه الوردية.',
  NLSOpsSitesErrorRoleCeiling: 'تعذر تعيين البديل: حد دور العضو يمنع التعيين.',
  NLSOpsSitesErrorGeneric: 'فشل تعيين البديل.',
  NLSOpsSitesErrorNotFound: 'السجل أو الطلب غير موجود.',
  NLSOpsSitesErrorMissingAttributes: 'الطلب يفتقر إلى سمات البديل المطلوبة.',
  NLSOpsSitesErrorInactivePerson: 'تعذر تعيين البديل: الشخص غير نشط في مساحة العمل.',
  NLSOpsRequestsUnassigned: 'غير معين',
  NLSOpsRequestsDetailUnassigned: 'غير معين',
  NLSOpsSitesIncidentsSubtitle: 'الحوادث (مقيدة) · شكاوى العملاء · طلبات التوريد · عمليات تدقيق الموقع',
  NLSOpsSitesIncidentsTitle: 'الحوادث',
  NLSOpsSitesRestrictedTag: 'مقيد',
  NLSOpsSitesAuditScoresTitle: 'درجات تدقيق الموقع',
  NLSOpsSitesSupervisorRegisterTag: 'سجل المشرف',
  NLSOpsSitesColSite: 'الموقع',
  NLSOpsSitesColLastAudit: 'آخر تدقيق',
  NLSOpsSitesColScore: 'الدرجة',
  NLSOpsSitesRecordAuditBtn: 'تسجيل تدقيق',
  NLSOpsSitesComplaintsSupplyTitle: 'الشكاوى وطلبات التوريد',
  NLSOpsSitesNoIncidents: 'لم يتم تسجيل أي حوادث.',
  NLSOpsSitesNoComplaintsSupply: 'لا توجد شكاوى أو طلبات توريد.',
  NLSOpsSitesNoAudits: 'لم يتم تسجيل أي تدقيق للموقع.',
  NLSOpsSitesNoAuditTemplate: 'لم يتم تكوين قالب تدقيق موقع المشرف.',
  NLSOpsSitesOpenTemplatesBtn: 'فتح القوالب',
} satisfies NlsStringMap

export default arStringsNls
